import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    "name": "rank",
    standalone: true
})
export class RankPipe implements PipeTransform {
    transform (value: number): string {
        if (!value && value !== 0){
            return "";
        }
        if (Math.abs(value) % 10 === 1 && Math.abs(value) % 100 !== 11){
            return value + "st";
        }
        if (Math.abs(value) % 10 === 2 && Math.abs(value) % 100 !== 12){
            return value + "nd";
        }
        if (Math.abs(value) % 10 === 3 && Math.abs(value) % 100 !== 13){
            return value + "rd";
        }
        else { return value + "th"; }
    }
}
